import { useFormikContext } from "formik";
import React, { FC, useState } from "react";
import { DEF_PG_SIZE_WIZARD } from "../../../../constants/maximum-page-size";
import { useLocale } from "../../../../contexts/localeContext";
import { TableContextProvider } from "../../../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import DepartmentColumns from "../../../../models/ColumnDefinitions/DepartmentColumns";
import DepartmentSearch from "../../../../models/search/DepartmentSearch";
import { getDepartments } from "../../../../services/departmentService";
import TableTab from "../../../tabs/table-tab";

interface DepartmentEntityProps {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    filterModalTrigger: string;
}

const DepartmentEntity: FC<DepartmentEntityProps> = ({ onBack, onNext }) => {
    const { translate } = useLocale();
    const [selectIds, setSelectIds] = useState<string[]>([]);
    const { setFieldValue } = useFormikContext<any>();

    const onSelectedIds = (selectedIds: string[]) => {
        setFieldValue('filterIds', selectedIds);
        setSelectIds([...selectedIds]);
    }

    return <div className="pt-3 pr-3 pl-3 h-full flex flex-col">
        <div className="flex-1 overflow-y-auto">
            <TableContextProvider
                dataMethod={getDepartments}
                useTable
                usePagination
                useSearch
                useSort
                tableDescriptor={DepartmentColumns}
                searchDescriptor={DepartmentSearch}
                maxPageSize={DEF_PG_SIZE_WIZARD}
                canExportReport={false}>
                <TableTab
                    title={translate.byKey(TranslationKeys.department)}
                    selectRows={true}
                    selectedIds={selectIds}
                    setSelectedIds={onSelectedIds}
                    tableId={'departmentEntity'}
                    cyName="departmentEntity" />
            </TableContextProvider>
        </div>

        <div className="flex flex-row justify-end mt-4 pr-3 pb-3">
            <div className="flex flex-row">
                <button className="py-1 px-5 secondary secondary-inverse" type="button" onClick={onBack}>
                    {translate.byKey(TranslationKeys.back)}
                </button>
            </div>
            <div className="flex flex-row justify-end pl-3">
                <button className="py-1 px-5 secondary secondary-enabled" type="button" onClick={e => onNext(e)}>
                    {translate.byKey(TranslationKeys.next)}
                </button>
            </div>
        </div>
    </div>
}

export default DepartmentEntity;
